export const MAX_CONVERSIONS_VALUE = {
  key: 'maximizeConversionsValue',
  text: _TL_('Maximize conversion value'),
  marketingMetric: 'roas',
  checkboxLabel: _TL_('Set a target return on ad spend (ROAS) (Optional)'),
  inputLabel: _TL_('Target return on ad spend'),
  inputUnit: '%',
  minValue: 1,
  maxValue: 100000,
  type: 'MaxConversionValue',
};

export const MAX_CONVERSIONS_VALUE_SCHEMA = {
  name: 'Product Schema',
  type: 'object',
  properties: {
    [MAX_CONVERSIONS_VALUE.marketingMetric]: {
      type: 'number',
      required: false,
      minimum: MAX_CONVERSIONS_VALUE.minValue,
      maximum: MAX_CONVERSIONS_VALUE.maxValue,
    },
  },
};
